// @flow
import { createTracker, EventTypes } from 'redux-segment';
import { LOCATION_CHANGE } from 'react-router-redux';
import userAuth from 'utils/user-auth';
import { localTutorLogout, postTutorSignInSuccess } from 'actions/tutor';

const identifyUser = () => {
  const { id: userId, attributes = {} } = userAuth.get();
  const { firstName, lastName, email } = attributes;

  return [
    {
      eventType: EventTypes.identify,
      eventPayload: {
        userId,
        traits: {
          name: `${firstName} ${lastName}`,
          email,
        },
      },
    },
  ];
};

const trackTutorLogout = () => [
  {
    eventType: EventTypes.track,
    eventPayload: {
      event: 'Tutor Logs Out',
    },
  },
  {
    eventType: EventTypes.reset,
  },
];

const customSegmentMapper = {
  mapper: {
    [LOCATION_CHANGE]: EventTypes.page,
    [postTutorSignInSuccess.toString()]: identifyUser,
    [localTutorLogout.toString()]: trackTutorLogout,
  },
};

const segmentTracker = createTracker(customSegmentMapper);

export default segmentTracker;



// WEBPACK FOOTER //
// ./src/store/middleware/segment.js